export const MESSENGER_SLICE_NAME = 'messaging';
export const MESSENGER_BASE_API_URL = '/messaging/v3';
export const MSG_DRAWER_WIDTH = 450;
export const DEBOUNCE_DELAY = 500;
export const DEFAULT_CHANNEL_TYPE = 'messaging';
export const MAX_CHANNEL_NAME_LENGTH = 40;
export const MAX_SEARCH_LENGTH = 80;
export const DEFAULT_PER_PAGE = 20;
export const TRACKING = {
  FIXED_CHANNEL: 'Fixed channel quick action',
  FILTER_CHANNEL: 'Role channel quick action',
  REPLY: 'reply',
  LOL: 'reaction lol',
  LIKE: 'reaction thumbs up',
  LOVE: 'reaction heart',
  SAD: 'reaction thumbs down',
  WOW: 'reaction ?!',
};
